import {getErros, getLogs} from '../../logger.js'
import {IconButton} from '@mui/material'
import {ContentCopyRounded, DeleteRounded, VisibilityRounded} from '@mui/icons-material'
import moment from 'moment'
import './logs.scss'
import {copy, isEmpty} from 'react-lf-tools'
import {useState} from 'react'
import {JsonView, allExpanded, darkStyles, defaultStyles} from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css'

const Logs = () => {
    const logs = getLogs()
    const errors = getErros()
    const [json, setJson] = useState({})

    const formatTime = (time) => moment(time).format('HH:mm DD/MM/YY')

    const handleDelete = (key) => {
        localStorage.removeItem(key)
        window.location.reload()
    }

    const handleCopy = async (key) => {
        const data = localStorage.getItem(key)
        const r = await copy(data)
        console.log(r)
    }

    const handleJson = async () => {
        const url = `${import.meta.env.VITE_GET_MENU}?authkey=${import.meta.env.VITE_AUTHKEY}&id=${import.meta.env.VITE_ID_STORE}&index=${import.meta.env.VITE_INDEX_STORE}`
        const res = await fetch(url)
        const r = await res.json()
        setJson(r)
    }

    const LogList = ({title, items, className, storage}) => (
        <div className='logs-errors'>
            <div className='div-title'>
                <h2>{title}</h2>
                <div className='div-buttons'>
                    <IconButton title={'Apagar'} onClick={() => handleDelete(storage)}>
                        <DeleteRounded className='icon'/>
                    </IconButton>
                    <IconButton title={'Copiar'} onClick={() => handleCopy(storage)}>
                        <ContentCopyRounded className='icon'/>
                    </IconButton>
                </div>
            </div>
            <div className='list'>
                {items.map((log, i) => (
                    <div key={log.id || i} className='div-logs'>
                        <label className='time'>{formatTime(log.time)}</label>
                        <label className={className}>{log.message}</label>
                    </div>
                ))}
            </div>
        </div>
    )

    const ViewJson = () => (
        <>
            <div className='logs-errors'>
                <div className='div-title'>
                    <h2>JSON menu</h2>
                    <div className='div-buttons'>
                        <IconButton title={'Apagar'} onClick={() => handleJson()}>
                            <VisibilityRounded className='icon'/>
                        </IconButton>
                    </div>
                </div>
            </div>
            {(!isEmpty(json)) && <div className='logs-errors'>
                <JsonView
                    data={json}
                    shouldExpandNode={allExpanded}
                    style={darkStyles}
                />
            </div>}
        </>
    )

    return <div className='container'>
        <ViewJson/>
        <LogList title='Logs' items={logs} className='log' storage='consoleLogs'/>
        <LogList title='Errors' items={errors} className='error' storage='consoleErrors'/>
    </div>
}

export default Logs

